import { attentionTypes } from '../global.enum';

export const ticketModel = {
  reasonsList: [],
  queueList: [],
  typificationList: [],
  priorityList: [],
  client: {
    document: '',
    fullName: '',
    shortName: '',
    platform: '',
  },
  appointmentList: [],
};

export const getAttentionName = (attentionType) => {
  switch (attentionType) {
    case attentionTypes.VIRTUAL:
      return 'Virtual';
    case attentionTypes.PRESENTIAL:
      return 'Presencial';
    default:
      return 'Sin definir';
  }
};

export const getDocumentValidation = (documentType) => {
  if (documentType === 1) {
    return 8;
  } else if (documentType === 2) {
    return 9;
  } else if (documentType === 3) {
    return 11;
  } else {
    return 0;
  }
};
